import { createTheme } from '@mui/material/styles';
import { colors } from '../constants/colors';

const theme = createTheme({
    palette: {
      primary: {
        main: colors.PRIMARY_900,
        light: colors.PRIMARY_500,
        text: colors.TEXT,
        border: colors.SHAPE,
        card: colors.CARD,
        success: colors.SUCCESS_900,
        card_ss_open: colors.CARD_SS_OPEN,
        card_ss_distributed: colors.CARD_SS_DISTRIBUTED,
        card_ss_closed: colors.CARD_SS_CLOSED,
      },
      secondary: {
        main: colors.SECONDARY_900
      },
      background: {
        main: colors.BACKGROUND
      },

    },
});

export default theme;

